/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import CardLayout from "../Cards/CardLayout";
import ReactECharts from "echarts-for-react";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import Loader from "../feedBacks/loader";
import CardError from "../feedBacks/CardError";
import NoContent from "../feedBacks/NoContent";
import { REFETCH_CONFIGURATION } from "../../utils/constants";
import { EChartsOption } from "echarts-for-react";
import { useEffect, useState } from "react";
import NoDeviceCardError from "../feedBacks/NoDeviceCardError";
import { useUtils } from "../../customHooks/useUtils";
import { formatCurrency } from "../../utils/utils";

interface IExpectedRevenueData {
  dataset: [string, number][];
  total_consumption: number;
  currency: string;
}

function ExpectedRevenueBySite({ company_id, startDate, endDate }: { company_id: string; startDate: string; endDate: string; }) {
 const { FEEDBACK_MESSAGES, t } = useUtils();
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const {
    data: powerConsumptionData,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData(
    ["/operations", "fetchRevenue", company_id],
    "/finance/expected-revenue-chart",
    {
      company_id,
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );

  const transformedData = powerConsumptionData
    ? (powerConsumptionData as IExpectedRevenueData).dataset
        .slice(1)
        .map(([title, value]) => ({
          title,
          consumption: value,
        }))
    : [];

  const isLoading =
    // Show loading for initial page load
    isDataLoading ||
    // Show loading when filter is applied and when actually refetching
    isLocalLoading;

  useEffect(() => {
    if (startDate && endDate) {
      setIsLocalLoading(true);

      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [startDate, endDate, refetch]);

  // Create properly formatted data for the chart
  const chartData = transformedData.map((item) => item.consumption);
  const chartLabels = transformedData.map((item) => item.title);

  const options: EChartsOption = {
    grid: {
      left: "5%",
      right: "15%",
      top: "3%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      max: "dataMax",
    },
    yAxis: {
      type: "category",
      data: chartLabels.length > 0 ? chartLabels : [FEEDBACK_MESSAGES.NO_DATA],
      inverse: true,
      animationDuration: 300,
      animationDurationUpdate: 300,
      axisLabel: {
        fontWeight: "bold",
        fontSize: 11,
        interval: 0, // Force show all labels
        width: 120,
        overflow: "truncate",
        align: "right",
      },
    },
    series: [
      {
        realtimeSort: true,
        name: t("chart.power_consumption"),
        type: "bar",
        color: "#9fdef1",
        data: chartData,
        label: {
          show: true,
          position: "right",
          valueAnimation: true,
          formatter: (params: any) =>
            `${formatCurrency(params.value)} ${
              (powerConsumptionData as IExpectedRevenueData)?.currency
            }`,
        },
      },
    ],
    // legend: {
    //   show: true,
    // },
    animationDuration: 0,
    animationDurationUpdate: 3000,
    animationEasing: "linear",
    animationEasingUpdate: "linear",
  };

  return (
    <CardLayout
      title={`${t("chart.expected_revenue")} (${
        (powerConsumptionData as IExpectedRevenueData)?.currency || "NGN"
      })`}
      className="lg:min-w-[570px] flex-1"
    >
      <div className="flex flex-col h-full w-full">
        {isLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <Loader />
          </div>
        ) : error ? (
          (error as any).response.data.detail ? (
            <NoDeviceCardError
              message={FEEDBACK_MESSAGES.NO_DEVICE}
              className="!max-h-[150px]"
            />
          ) : (
            <CardError
              message={FEEDBACK_MESSAGES.ERROR}
              className="!h-[100px]"
            />
          )
        ) : transformedData.length === 0 ? (
          <NoContent message={FEEDBACK_MESSAGES.NO_DATA} />
        ) : (
          <div className="h-full w-full relative p-0">
            <ReactECharts
              option={options}
              // style={{ height: "100%", width: "100%" }}
              // opts={{ renderer: "canvas" }}
            />
          </div>
        )}
      </div>
    </CardLayout>
  );
}

export default ExpectedRevenueBySite;
